var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91699 8.75L12.9985 14.4622C16.7152 16.5681 18.2855 16.5681 22.0022 14.4622L32.0837 8.75",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93999 19.6519C3.03532 24.1226 3.08299 26.3578 4.73256 28.0137C6.38211 29.6695 8.67789 29.7271 13.2695 29.8425C16.0993 29.9136 18.9013 29.9136 21.7312 29.8425C26.3228 29.7271 28.6185 29.6695 30.2682 28.0137C31.9177 26.3578 31.9654 24.1226 32.0606 19.6519C32.0914 18.2144 32.0914 16.7856 32.0606 15.3481C31.9654 10.8775 31.9177 8.64222 30.2682 6.98639C28.6185 5.33055 26.3228 5.27287 21.7312 5.1575C18.9013 5.0864 16.0993 5.0864 13.2694 5.15749C8.67789 5.27284 6.38211 5.33052 4.73254 6.98637C3.08298 8.64221 3.03532 10.8775 2.93998 15.3481C2.90932 16.7856 2.90934 18.2144 2.93999 19.6519Z",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/SendMessage.9b41427930b43acf32a8f2b87a518e00.svg";
export { ForwardRef as ReactComponent };